<script setup lang="ts">
import InsightsList from '@/components/insights/InsightsList.vue';
import { setTitle } from '@/utils/title';

setTitle('All Insights');
</script>

<template>
  <InsightsList />
</template>
